import { primaryWorkerOptions } from 'src/components/Cases/utils';

export const toPrimaryWorkerOptions = (groupsUsers) => (
  primaryWorkerOptions({ groupsUsers }).map((option) => ({
    ...option,
    value: option.value == null ? '' : String(option.value),
    label: option.label,
  }))
);

export const normalizeSearchInput = (inputValue = '') => inputValue.trim();

export const shouldFetchPrimaryWorkers = (action, normalizedInput) => (
  action === 'input-change' || normalizedInput === ''
);

export const getPrimaryWorkerValue = (selectedValue) => selectedValue || null;

export const callPrimaryWorkerChange = (field, selectedValue) => {
  if (field?.onChange) {
    field.onChange(getPrimaryWorkerValue(selectedValue));
  }
};

export const callPrimaryWorkerBlur = (field) => {
  if (field?.onBlur) {
    field.onBlur();
  }
};
